import { useCallback, useMemo } from 'react'

import getUserLocale from 'get-user-locale'

import {
    getDateFormat,
    getDateStringValue,
    getDateValue,
} from 'features/views/attributes/editable/utils'

type UseSectionDateAttributeEditorStateProps = {
    value?: string
    onChange: (value: string) => void
    field: FieldDto
}

export function useSectionDateAttributeEditorState({
    value,
    onChange,
    field,
}: UseSectionDateAttributeEditorStateProps) {
    const showTime = field.type === 'datetime'
    const timezone = field.options?.timezone

    const dateValue = useMemo(() => {
        return getDateValue(value, timezone, showTime)
    }, [timezone, value, showTime])

    const locale = getUserLocale()

    const dateFormat = useMemo(() => {
        return getDateFormat(locale, showTime)
    }, [showTime, locale])

    const handleChange = useCallback(
        (value: Date | [Date, Date]) => {
            const newValue = Array.isArray(value) ? value[0] : value

            const formattedDate = getDateStringValue(newValue, timezone, showTime)
            onChange(formattedDate ?? '')
        },
        [timezone, showTime, onChange]
    )

    return {
        localValue: dateValue,
        handleChange,
        showTime,
        dateFormat,
    }
}
